// import React from "react";
// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import { authRoutes, allRoutes } from "./Routes/AllRoutes";
// import NonAuthLayout from "./Routes/middleware/NonAuthLayout";
// import AuthLayout from "./Routes/middleware/AuthLayout";
// import Layout from "./Screens/Layout/Layout";
// import NotFound from "./Screens/Status/NotFound";
// import Unauthorized from "./Screens/Status/Unauthorized";
// import ResetPasswordPage from "./Components/User/ResetPasswordPage";
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const App = () => (
//   <BrowserRouter>
//     <ToastContainer
//       position="top-center"
//       autoClose={3000}
//       hideProgressBar={false}
//       newestOnTop={false}
//       closeOnClick
//       rtl={false}
//       pauseOnFocusLoss
//       draggable
//       pauseOnHover
//       theme="colored"
//     />
//     <Routes>
//       {authRoutes.map(({ path, component }, idx) => (
//         <Route
//           key={idx}
//           path={path}
//           element={<NonAuthLayout>{component}</NonAuthLayout>}
//         />
//       ))}

//       {allRoutes.map(({ path, component }, idx) => (
//         <Route
//           key={idx}
//           path={path}
//           element={
//             <AuthLayout>
//               <Layout>{component}</Layout>
//             </AuthLayout>
//           }
//         />
//       ))}

//       <Route path="/unauthorized" element={<Unauthorized />} />
//       <Route path="*" element={<NotFound />} />
//     </Routes>
//   </BrowserRouter>
// );

// export default App;

import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { authRoutes, allRoutes } from "./Routes/AllRoutes";
import NonAuthLayout from "./Routes/middleware/NonAuthLayout";
import AuthLayout from "./Routes/middleware/AuthLayout";
import Layout from "./Screens/Layout/Layout";
import NotFound from "./Screens/Status/NotFound";
import Unauthorized from "./Screens/Status/Unauthorized";
import ResetPasswordPage from "./Components/User/ResetPasswordPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { UserProvider } from "./Context/UserContext";

const App = () => {
  useEffect(() => {
    const blockKeys = (e) => {
      const key = e.key.toLowerCase();
      if (
        key === "f12" ||
        (e.ctrlKey && e.shiftKey && ["i", "j", "c"].includes(key)) ||
        (e.ctrlKey && key === "u")
      ) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    };

    const blockContextMenu = (e) => {
      const allowedTags = ["INPUT", "TEXTAREA", "SELECT"];
      const isContentEditable = e.target?.isContentEditable;

      // Allow native context menu on input-like elements (fixes mobile copy/paste)
      if (allowedTags.includes(e.target?.tagName) || isContentEditable) {
        return;
      }

      e.preventDefault();
      return false;
    };

    window.addEventListener("keydown", blockKeys, true);
    window.addEventListener("contextmenu", blockContextMenu, true);

    return () => {
      window.removeEventListener("keydown", blockKeys, true);
      window.removeEventListener("contextmenu", blockContextMenu, true);
    };
  }, []);

  return (
    <BrowserRouter>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <Routes>
        {authRoutes.map(({ path, component }, idx) => (
          <Route
            key={idx}
            path={path}
            element={<NonAuthLayout>{component}</NonAuthLayout>}
          />
        ))}

        {allRoutes.map(({ path, component }, idx) => (
          <Route
            key={idx}
            path={path}
            element={
              <AuthLayout>
                <Layout>{component}</Layout>
              </AuthLayout>
            }
          />
        ))}

        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
